import React from 'react';
import Layout from '../components/Layout';
import Cart from '../components/Cart/Cart';

const CartPage = ({location}) => (
  <Layout>
    {location.state && location.state.message && <div> {location.state.message} </div>}
    <Cart />
  </Layout>
);

export default CartPage;
